
import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import { BASE_OPTION_CLASSES } from "%/dynamic-component-editor/options/subscription-action/subscription-action-options";

export default class SubscriptionButtonBaseOptions extends BaseOptionsBundle {
  optionTitle = "Button";
  static optionClassName = "i-subscription-button-base";
  inspectorToolGroup = "subscriptionButtonBase";
  useInspectorLabel = false;
  static userInterfaceComponent = {
    component: inspectorTools.GROUPED_OPTIONS_TOOL_SET,
  };

  constructor(values = {}) {
    super(values, [
      BASE_OPTION_CLASSES.variant,
      BASE_OPTION_CLASSES.size,
      BASE_OPTION_CLASSES.text,
      BASE_OPTION_CLASSES.fontColor,
      BASE_OPTION_CLASSES.backgroundColor,
      BASE_OPTION_CLASSES.borderColor,
      BASE_OPTION_CLASSES.borderWidth,
      BASE_OPTION_CLASSES.icon,
      BASE_OPTION_CLASSES.iconPosition,
      BASE_OPTION_CLASSES.iconColor,
      BASE_OPTION_CLASSES.gap,
    ]);
  }
}
